import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

export function createResetPwdForm(fb: FormBuilder): FormGroup<{ email: FormControl<string | null> }> {
  return fb.group({
    email: ['', [Validators.required, Validators.email]],
  });
}